import { Environment } from 'src/app/models/environment.model';

// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment: Environment = {
  name: 'simarik',
  production: false,
  api: {
    url: 'https://api.develop.simarikapp.com',
    // url: 'http://localhost:4000',
  },
  google: {
    // simarikapp-develop-2
    // @url https://console.cloud.google.com/apis/credentials?project=simarikapp-develop
    apiKey: 'AIzaSyA7zDn8uNDtuLml11f-r37xDqII9bAC_ec',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
